<template>
  <div class="flex items-center my-1">

    <div class="h-full flex-grow">
      <!-- title -->
      <p v-if="pack || modelValue.contactTrainingModule?.packageTrainingModule?.name"
        class="text-xl font-semibold text-gray-900">
        <NuxtLink v-if="contactPack" :to="`/training/${contactPack.contactPackageId}#comment_${modelValue.id}`">
          {{ modelValue.contactTrainingModule?.packageTrainingModule?.name || '' }}
        </NuxtLink>
        <span v-else>
          {{ modelValue.contactTrainingModule?.packageTrainingModule?.name || '' }}
        </span>
        <span class="block text-sm text-gray-400">
          {{ pack?.name }}
        </span>
      </p>
      <!-- content -->
      <div class="flex-grow text-sm text-gray-500 whitespace-pre-wrap" :class="{ 'line-clamp-6': $props.truncate }"
        :title="$props.truncate ? modelValue.content : undefined">
        <span style="overflow-wrap: anywhere;">{{ modelValue.content }}</span>
      </div>
      <div v-if="user" class="flex items-center pt-2">
        <div class="flex-shrink-0">
          <UserIcon :user="user" />
        </div>
        <div class="ml-3">
          <p class="text-sm font-medium text-gray-900">
            {{ user.firstname }} {{ user.lastname }}
          </p>
          <div class="flex space-x-1 text-sm text-gray-500 min-h-4">
            <time :datetime="$format.dateISO(modelValue.createdAt)">
              {{ $format.date(modelValue.createdAt) }}
            </time>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { PencilIcon, CheckIcon, XMarkIcon, TrashIcon } from '@heroicons/vue/24/outline'

import type { IComment } from '@/api/myedvenn/comment'

import CommentContactedBy from './ContactedBy.vue'

export default defineComponent({
  name: 'CommentTrainee',
  props: {
    modelValue: Object as PropType<IComment>,

    truncate: Boolean
  },
  components: { PencilIcon, CheckIcon, XMarkIcon, TrashIcon, CommentContactedBy },
  setup(props) {
    const { $store } = useNuxtApp()

    return {
      user: computed(() =>
        $store.cache.getUser(props.modelValue?.user)
      ),

      pack: computed(() =>
        $store.cache.getPackage(props.modelValue?.packageFile?.package)
      ),

      contactPack: computed(() =>
        $store.trainee.contactPackagesAll.find(cp => cp.packageId === props.modelValue?.packageFile?.package?.id)
      )
    }
  }
})
</script>